import React from "react";

export const StateTypeFormatter = (cellContent, row, rowIndex) => {
  const { stateId } = row;
  const { state_name = "-" } = stateId || {};
  return (
    <>
      <div className="d-flex align-items-center text-capitalize">
        {`${state_name} `}
      </div>
      <> </>
    </>
  );
};
